<section class="o-section">
  <div class="o-wrapper">
    <div class="o-layout">
      <div class="o-layout__item [ u-10/12@desktop u-push-1/12@desktop ]">

        <div class="hipaa-consent">
          <div *ngIf="isLoadingContent" class="hipaa-content-loading">
            <div class="c-loader c-loader--inline"></div>
          </div>

          <div *ngIf="!isLoadingContent && !contentLoadError" class="hipaa-content" [innerHTML]="consentContent"></div>

          <div class="c-form-field c-form-field--buttons c-form-field--buttons-wizard">
            <div class="c-form-field--buttons-wizard__next">
              <button class="c-btn c-btn--primary" type="button" (click)="onAccept()" [disabled]="contentLoadError || isLoadingContent">
                {{ "HIPAA-CONSENT.pre_therapy_hipaa_consent_primary_button_text" | translate }}
              </button>
            </div>
            <div class="c-form-field--buttons-wizard__back">
              <button class="c-btn c-btn--secondary" type="button" (click)="onDecline()" [disabled]="contentLoadError || isLoadingContent">
                {{ "HIPAA-CONSENT.pre_therapy_hipaa_consent_secondary_button_text" | translate }}
              </button>
            </div>
          </div>

          <div class="u-margin-top">
            <button class="c-btn c-btn--tertiary" type="button" (click)="onCancel()">
              {{"REGISTRATION-FORM.Cancel" | translate}}
            </button>
          </div>
        </div>

      </div>
    </div>
  </div>
</section>
